import React from "react";
import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const SessionsContent = dynamic(() => import('../components/static/sessionsPage/sessions'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';
import { getSessions } from "../api/sessions";

function Sessions(props) {

  const meta = {
    title: "Sessions | Chicago | Bayan",
    description: "All courses take place over the brief term, regardless of the format in which they are offered and when face-to-face instruction and/or online class meetings occur.",
    route: "session",
  }
  return (
    <>
      <Layout theme={props.theme} meta={meta}>
        <SessionsContent router={props.router} sessions={props?.sessions} />
      </Layout>
    </>
  );
}

export async function getServerSideProps(ctx) {
  let sessions = await getSessions();
  return { props: { sessions: sessions?sessions:"KS" } }
}

export default withRouter(Sessions);
